import { Directive, ElementRef, Renderer2 } from '@angular/core';
@Directive({
  selector: '[tooltipCleaner]',
  standalone: false,
})
export class TooltipCleanerDirective {
  private nativeElement : Node;
  constructor( private renderer : Renderer2, private element : ElementRef ) {
    this.nativeElement = element.nativeElement;
  }
}